module.exports = __webpack_public_path__ + "img/era.ad51d0c7.jpg";